import type * as React from "react";
import classNames from "classnames";

import classes from "./Chip.module.less";

interface Props {
  type?: "blue" | "grey" | "notification" | "salesCampaign";
}

export const Chip: React.FC<JSX.IntrinsicElements["div"] & Props> = ({ className, type, ...props }) => (
  <div {...props} className={classNames(classes.root, !!type && classes[type], className)} />
);
export default Chip;
